import { apiFetch } from 'services/apiClient';
import { Page } from '../../../types/Page';
import { ReportNode } from '../types/ReportNode';

export const listReportNodes = (page = 0, size = 10, sort?: string, query?: string): Promise<Page<ReportNode>> =>
  apiFetch('/report-nodes?page=' + page + '&size=' + size + (sort ? '&sort=' + sort : '') + (query ? '&' + query : ''));
export const listReportNodesAll = (query?: string): Promise<ReportNode[]> => apiFetch('/report-nodes/all' + (query ? ('?' + query) : ''));
export const getReportNode = (id: number): Promise<ReportNode> => apiFetch('/report-nodes/' + id);
export const createReportNode = (data: any): Promise<ReportNode> =>
  apiFetch('/report-nodes', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const updateReportNode = (id: number, data: any): Promise<ReportNode> =>
  apiFetch('/report-nodes/' + id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const deleteReportNode = (id: number): Promise<void> =>
  apiFetch('/report-nodes/' + id, { method: 'DELETE' });
